(function () {
  'use strict';

  if (window.AorvoTieredOffer) return;

  var tiers = [
    { code: 'AO24', percent: 24, threshold: 0, nextThreshold: 350000 },
    { code: 'AO27', percent: 27, threshold: 350000, nextThreshold: 800000 },
    { code: 'AO30', percent: 30, threshold: 800000, nextThreshold: null }
  ];
  var lastDialogTrigger = null;
  var cartDrawerObserver = null;
  var cartDrawerMountRequest = null;

  function resolveTier(subtotal) {
    if (subtotal >= tiers[2].threshold) return tiers[2];
    if (subtotal >= tiers[1].threshold) return tiers[1];
    return tiers[0];
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var moneyFormat = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : '${{amount}}';
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
  }

  function ensureCartDrawerCopyButton(element, tier) {
    if (!element.closest('#desktop_cart') || !element.dataset.copyLabel || !element.dataset.copiedLabel) return;
    var controls = element.querySelector('[data-aorvo-drawer-copy]');
    if (!controls) {
      controls = document.createElement('div');
      controls.className = 'aorvo-tiered-offer__footer';
      controls.setAttribute('data-aorvo-drawer-copy', '');

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'aorvo-tiered-offer__copy';
      var code = document.createElement('span');
      code.className = 'aorvo-tiered-offer__code';
      code.setAttribute('data-aorvo-drawer-code', '');
      var label = document.createElement('span');
      label.setAttribute('data-aorvo-copy-label', '');
      button.appendChild(code);
      button.appendChild(label);

      var status = document.createElement('span');
      status.className = 'visually-hidden';
      status.setAttribute('data-aorvo-copy-status', '');
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      controls.appendChild(button);
      controls.appendChild(status);
      element.appendChild(controls);
    }

    var copyButton = controls.querySelector('[data-aorvo-copy-code]') || controls.querySelector('button');
    copyButton.setAttribute('data-aorvo-copy-code', tier.code);
    copyButton.setAttribute('data-copy-label', element.dataset.copyLabel);
    copyButton.setAttribute('data-copied-label', element.dataset.copiedLabel);
    var code = copyButton.querySelector('[data-aorvo-drawer-code]');
    var label = copyButton.querySelector('[data-aorvo-copy-label]');
    if (code.textContent !== tier.code) code.textContent = tier.code;
    if (label.textContent !== element.dataset.copyLabel && label.textContent !== element.dataset.copiedLabel) {
      label.textContent = element.dataset.copyLabel;
    }
  }

  function updateCartOffer(element, subtotal) {
    var tier = resolveTier(subtotal);
    var summary = element.querySelector('[data-aorvo-offer-summary]');
    var next = element.querySelector('[data-aorvo-offer-next]');
    var progress = element.querySelector('[data-aorvo-offer-progress]');
    var progressbar = element.querySelector('[role="progressbar"]');
    var labels = element.dataset;
    var progressValue = tier.nextThreshold ? Math.min(100, subtotal / tier.nextThreshold * 100) : 100;

    element.dataset.subtotalCents = String(subtotal);
    if (tier.nextThreshold) {
      summary.innerHTML = labels.labelQualified + ' <strong>' + tier.percent + '% ' + labels.labelOffWith + ' ' + tier.code + '</strong>.';
      next.innerHTML = labels.labelAdd + ' <strong>' + formatMoney(tier.nextThreshold - subtotal) + '</strong> ' + labels.labelToUnlock + ' ' + tiers[tiers.indexOf(tier) + 1].percent + '% ' + labels.labelOffWith + ' ' + tiers[tiers.indexOf(tier) + 1].code + '.';
      next.hidden = false;
    } else {
      summary.innerHTML = labels.labelHighest + ' <strong>' + tier.percent + '% ' + labels.labelOffWith + ' ' + tier.code + '</strong>.';
      next.hidden = true;
      next.textContent = '';
    }
    progress.style.width = progressValue + '%';
    progressbar.setAttribute('aria-valuenow', String(Math.round(progressValue)));
    ensureCartDrawerCopyButton(element, tier);
  }

  function updateCartOffers(cart) {
    if (!cart || typeof cart.items_subtotal_price !== 'number') return;
    document.querySelectorAll('[data-aorvo-tiered-offer="cart"]').forEach(function (element) {
      updateCartOffer(element, cart.items_subtotal_price);
    });
  }

  function fetchCart() {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(updateCartOffers)
      .catch(function () {});
  }

  function mountCartDrawerOffer() {
    var cartInfo = document.getElementById('cart-info');
    var footer = cartInfo && cartInfo.querySelector('.ajaxcart__footer');
    if (!footer) return;
    var existingOffer = footer.querySelector('[data-aorvo-tiered-offer="cart"]');
    if (existingOffer) {
      ensureCartDrawerCopyButton(existingOffer, resolveTier(Number(existingOffer.dataset.subtotalCents) || 0));
      return;
    }
    if (cartDrawerMountRequest) return;

    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    cartDrawerMountRequest = fetch(root + 'cart?view=json', { credentials: 'same-origin' })
      .then(function (response) { return response.ok ? response.text() : ''; })
      .then(function (html) {
        var currentFooter = document.querySelector('#desktop_cart #cart-info .ajaxcart__footer');
        if (!currentFooter || currentFooter.querySelector('[data-aorvo-tiered-offer="cart"]') || !html) return;

        var responseDocument = new DOMParser().parseFromString(html, 'text/html');
        var offer = responseDocument.querySelector('[data-aorvo-tiered-offer="cart"]');
        if (!offer) return;

        var mountedOffer = document.importNode(offer, true);
        currentFooter.insertBefore(mountedOffer, currentFooter.firstChild);
        ensureCartDrawerCopyButton(mountedOffer, resolveTier(Number(mountedOffer.dataset.subtotalCents) || 0));
        fetchCart();
      })
      .catch(function () {})
      .then(function () { cartDrawerMountRequest = null; });
  }

  function observeCartDrawer() {
    var cartInfo = document.getElementById('cart-info');
    if (!cartInfo || cartDrawerObserver) return;
    cartDrawerObserver = new MutationObserver(mountCartDrawerOffer);
    cartDrawerObserver.observe(cartInfo, { childList: true, subtree: true });
    mountCartDrawerOffer();
  }

  function copyText(value) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(value);
    }
    return new Promise(function (resolve, reject) {
      var input = document.createElement('textarea');
      input.value = value;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      try {
        document.execCommand('copy') ? resolve() : reject(new Error('Copy failed'));
      } catch (error) {
        reject(error);
      }
      input.remove();
    });
  }

  function openDialog(trigger) {
    var dialog = document.getElementById('AorvoTieredOfferDialog');
    if (!dialog) return;
    lastDialogTrigger = trigger;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    var closeButton = dialog.querySelector('[data-aorvo-offer-close]');
    if (closeButton) closeButton.focus();
  }

  function closeDialog() {
    var dialog = document.getElementById('AorvoTieredOfferDialog');
    if (!dialog) return;
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
    if (lastDialogTrigger) lastDialogTrigger.focus();
  }

  document.addEventListener('click', function (event) {
    var openTrigger = event.target.closest('[data-aorvo-offer-open]');
    if (openTrigger) {
      event.preventDefault();
      openDialog(openTrigger);
      return;
    }

    if (event.target.closest('[data-aorvo-offer-close]')) {
      event.preventDefault();
      closeDialog();
      return;
    }

    var copyButton = event.target.closest('[data-aorvo-copy-code]');
    if (!copyButton) return;
    event.preventDefault();
    var label = copyButton.querySelector('[data-aorvo-copy-label]');
    var status = copyButton.closest('[data-aorvo-tiered-offer]').querySelector('[data-aorvo-copy-status]');
    copyText(copyButton.dataset.aorvoCopyCode).then(function () {
      label.textContent = copyButton.dataset.copiedLabel;
      if (status) status.textContent = copyButton.dataset.aorvoCopyCode + ' ' + copyButton.dataset.copiedLabel;
      window.setTimeout(function () {
        label.textContent = copyButton.dataset.copyLabel;
      }, 1600);
    }).catch(function () {
      if (status) status.textContent = copyButton.dataset.aorvoCopyCode;
    });
  });

  document.addEventListener('click', function (event) {
    var dialog = event.target;
    if (!dialog.matches || !dialog.matches('#AorvoTieredOfferDialog')) return;
    var bounds = dialog.getBoundingClientRect();
    var outside = event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom;
    if (outside) closeDialog();
  });

  ['cart:updated', 'cart:change', 'aorvo:cart-updated'].forEach(function (eventName) {
    document.addEventListener(eventName, function (event) {
      updateCartOffers(event.detail && (event.detail.cart || event.detail));
    });
  });

  function attachAjaxListener() {
    if (!window.jQuery) return;
    window.jQuery(document).ajaxSuccess(function (_event, xhr, settings, responseData) {
      var url = settings && settings.url ? settings.url : '';
      if (!/\/cart\/(add|change|update)(\.js)?(?:\?|$)/.test(url)) return;
      var cart = responseData;
      if (typeof cart === 'string') {
        try { cart = JSON.parse(cart); } catch (_error) { cart = null; }
      }
      if (cart && typeof cart.items_subtotal_price === 'number') updateCartOffers(cart);
      else window.setTimeout(fetchCart, 0);
    });
  }

  function initialize() {
    attachAjaxListener();
    observeCartDrawer();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();

  window.AorvoTieredOffer = {
    resolveTier: resolveTier,
    updateCartOffers: updateCartOffers
  };
})();
